import React, { useState } from "react";
import { BiSlideshow } from "react-icons/bi";
import { GiNotebook } from "react-icons/gi";
import SciencePopUp from "../PopUp/Science/SciencePopUp";
import "./Time-table-wek-events.css";
/**
 * Displayes all events (Assesment, Slide show etc. ) in the event for week view
 * @param {*} param0
 * @returns
 */
const TimeTableWeekEvents = ({ event }) => {
  // debugger;
  const [popup, setPopUp] = useState();
  return event ? (
    <div className="d-flex gap-2 mt-1">
      {event?.Events?.map((item, index) => {
        switch (item?.name) {
          case "pre_read":
            return (
              <div key={index} className="">
                {/* <GiNotebook size={"16px"} onClick={(e) => setPopUp(true)} /> */}
                <img src="images/preRead.svg" alt="" className="icns" />
              </div>
            );
          case "activity":
            return (
              <div key={index} className="">
                {/* <GiNotebook size={"16px"} onClick={(e) => setPopUp(true)} /> */}
                <img src="images/activity.svg" alt="" className="icns" />

              </div>
            );
          case "homework":
            return (
              <div key={index} className="">
                {/* <GiNotebook size={"16px"} onClick={(e) => setPopUp(true)} /> */}
                <img src="images/Homework 2.svg" alt="" className="icns" />
              </div>
            );
          case "assessment":
            return (
              <div key={index} className="icon">
                {/* <GiNotebook size={"16px"} onClick={(e) => setPopUp(true)} /> */}
                <img src="images/Assessment 2.svg" alt="" className="icns" />
              </div>
            );
          default:
            return <></>;
        }
      })}
      {popup && <SciencePopUp setScience={setPopUp} />}
    </div>
  ) : (
    <></>
  );
};

export default TimeTableWeekEvents;
